import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/AuthView.vue"),
    meta: {
      title: "Inicia sesión | Backoffice ",
    },
  },
  {
    path: "/resetPass",
    name: "resetPass",
    component: () => import("../views/ResetPassView.vue"),
    meta: {
      title: "Restablece tu contraseña | Backoffice",
    },
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/DashboardView.vue"),
        meta: {
          title: "Inicio | Backoffice",
        },
      },
      {
        path: "/reportes",
        name: "reportes",
        component: () => import("../views/ReportesView.vue"),
        meta: {
          title: "Reportes | Backoffice ",
        },
      },
      {
        path: "/reporteFechaServicio",
        name: "reporteFechaServicio",
        component: () => import("../views/ReporteFechaServicioView.vue"),
        meta: {
          title: "Reportes | Backoffice",
        },
      },
      {
        path: "/eventos",
        redirect: "/eventos/1",
      },
      {
        path: "/eventos/:page",
        name: "eventos",
        component: () => import("../views/EventosView.vue"),
        meta: {
          title: "Eventos | Backoffice ",
        },
      },
      {
        path: "/evento/:idEvento",
        name: "evento",
        component: () => import("../views/EventoView.vue"),
        meta: {
          title: "Evento | Backoffice ",
        },
      },
      {
        path: "/localidades/:idEvento",
        name: "localidades",
        component: () => import("../views/LocalidadesView.vue"),
        meta: {
          title: "Localidades | Backoffice ",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? "Backoffice";
});

export default router;
